import React from 'react'
import { isMobile } from 'react-device-detect'
import { Button } from '@/atoms/Button'
import { FlexColumn } from '@/atoms/FlexContainers'
import { CloseIcon } from '@/atoms/Icons/CloseIcon'
import { TicketIcon } from '@/atoms/Icons/TicketIcon'
import { HeadingXS, ParagraphMD, ParagraphSM, TitleSM } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

interface DefaultStepProps {
  handleGiftClick: () => void
  onClose: () => void
  onCopyClick: () => void
}
export const DefaultStep = ({ handleGiftClick, onClose, onCopyClick }: DefaultStepProps) => {
  const { t } = useTranslate('common')

  return (
    <>
      <div className="absolute right-6 top-6 cursor-pointer rounded-full bg-black/10 p-1.5" onClick={onClose}>
        <CloseIcon color="black" size={18} />
      </div>
      <FlexColumn className="gap-8 pb-8">
        <FlexColumn className="gap-2">
          <div className="mx-auto mb-4 rounded-full bg-warning-50 p-[1.125rem]">
            <TicketIcon size={32} color="warm-03" />
          </div>
          <HeadingXS weight="bold" className="text-[1.25rem] leading-[2rem] -tracking-[0.03125rem] md:text-[1.75rem]">
            {t('shareTheLightHeading', 'Share the Light')}
          </HeadingXS>
          <ParagraphMD
            weight={'medium'}
            color={'core-gray-700'}
            className="text-[0.875rem] leading-[1.625rem] md:text-base md:leading-[1.75rem]"
          >
            {t(
              'sharethelightguild',
              'Use your tickets to invite someone or gift them to someone who needs a little light.',
            )}
          </ParagraphMD>
        </FlexColumn>
      </FlexColumn>
      <FlexColumn className="gap-2">
        <FlexColumn className="gap-3 rounded-xl border border-gray-200 bg-gray-100 md:gap-8">
          <div className={'flex flex-col gap-3 p-3 md:flex-row md:gap-6 md:p-4'}>
            <FlexColumn className="items-start gap-1.5 md:gap-2">
              <TitleSM weight="semibold">{t('ShareYourGuildTickets', 'Share Your Tickets')}</TitleSM>
              <ParagraphSM
                weight={'medium'}
                className="text-left text-[0.8125rem] leading-[1rem] md:text-sm md:leading-[1.625rem]"
                color={'gray-700'}
              >
                {t('ShareYourGuildTicketsDescription', 'Send your tickets to a friend or family member.')}
              </ParagraphSM>
            </FlexColumn>
            <FlexColumn className={'md:justify-center'}>
              <Button
                onClick={onCopyClick}
                className="min-w-[9.375rem] items-center gap-1.5 rounded-[0.875rem] px-5 py-3 text-sm font-normal"
                variant="black"
              >
                {isMobile ? t('shareMyTickets', 'Share My Tickets') : t('copyInviteLink', 'Copy Invite Link')}
              </Button>
            </FlexColumn>
          </div>
        </FlexColumn>

        <FlexColumn className="gap-3 rounded-xl border border-gray-200 bg-gray-100 md:gap-8">
          <div className={'flex flex-col gap-3 p-3 md:flex-row md:gap-6 md:p-4'}>
            <FlexColumn className="items-start gap-1.5 md:gap-2">
              <TitleSM weight="semibold">{t('LetAngelGiftTickets', 'Let Angel Share Them')}</TitleSM>
              <ParagraphSM
                weight={'medium'}
                className="text-left text-[0.8125rem] leading-[1rem] md:text-sm md:leading-[1.625rem]"
                color={'gray-700'}
              >
                {t('giftYourGuildTicketsDescription', "Can't use your tickets? We'll gift your tickets for you.")}
              </ParagraphSM>
            </FlexColumn>
            <FlexColumn className={'md:justify-center'}>
              <Button
                onClick={handleGiftClick}
                className="min-w-[9.375rem] items-center gap-1.5 rounded-[0.875rem] px-5 py-3 text-sm font-normal"
                variant="oxide"
              >
                {t('GiftMyTicketsBtn', 'Gift My Tickets')}
              </Button>
            </FlexColumn>
          </div>
        </FlexColumn>
      </FlexColumn>
    </>
  )
}
